import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Msg } from '../model/user.model';
import { AuthService } from '../service/auth.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
    form: UntypedFormGroup;
    isLoading: boolean = false;

    msg: Msg = new Msg();

    constructor(private fb: UntypedFormBuilder, private auth: AuthService, private router: Router, private store: Store<AppState>) {
        this.form = fb.group({
            email: ['', [Validators.email, Validators.required]],
            captcha: ['', []]
        });
    }

    ngOnInit(): void {}

    submit() {
        this.isLoading = true;
        const val = this.form.value;
        this.auth
            .forgotPassword(val.email)
            .pipe()
            .subscribe((res) => {
                this.isLoading = false;
                if (res['msg']) {
                    this.msg = res['msg'];
                }
            });
    }
}
